import React from 'react';
import './App.css';
import RollDice from './RollDice';

function App() {
  return (
    <div className="App">
      <RollDice/>
    </div>
  );
}

export default App;
